module.exports = __webpack_public_path__ + "img/download.f61c7958.svg";